import type { CanDeactivateFn } from '@angular/router';

/**
 * Implemented by a routed page that can hold unsaved changes. `canLeave` returns `true` when
 * there is nothing to lose; otherwise it shows the discard prompt and resolves with the answer.
 */
export interface CanLeave {
  canLeave(): boolean | Promise<boolean>;
}

/** Asks the page whether it can be left, so unsaved form changes are never dropped silently. */
export const unsavedChangesGuard: CanDeactivateFn<CanLeave> = (component) => component.canLeave();
